















import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import SearchProducer from '@/mixins/search-queries/search-producer'
import { ICaseSourceInput } from '@/modules/Case/interfaces/case-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField
  }
})
export default class CaseFormSource extends mixins(SearchProducer) {
  @Prop({ type: Object as () => ICaseSourceInput }) value!: ICaseSourceInput

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
